<template>
  <div v-cloak v-if="ch" class="item-common pt-10 pl-7 pr-5">
    <div class="header pb-4" v-if="ch.categoryGuide">
      <p class="desc" v-html="ch.categoryGuide"></p>
    </div>
    <v-form ref="form">
      <v-row
        class="mt-2 mb-8"
        v-for="(selectList, key) in categoriesSelected"
        :key="key"
      >
        <v-col
          cols="12"
          v-for="(item, idx) in categories"
          class="pb-0 pl-0 pr-3"
          :class="{
            'col-md-12': categories.length == 1,
            'col-md-6': categories.length == 2,
            'col-md-4': categories.length == 3,
            'col-md-3': categories.length == 4,
            'col-md-2': categories.length > 4,
          }"
          :key="'category' + idx"
        >
          <i-select
            v-model="selectList[idx]"
            :label="
              categoriesSelected.length != 1
                ? `${key + 1}` + $t('지망') + `${$t(item.name)}`
                : item.name
            "
            outlined
            dense
            hide-details="auto"
            :readonly="isReadonly"
            :items="filter(item.items, selectList)"
            @change="change(idx, key != 0 ? 'Y' : 'N')"
            :rules="[rules.required]"
          ></i-select>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import { snack } from '@/plugins/dialog/api';
const delimeter = '#';
export default {
  props: {
    ch: { type: Object },
    ci: { type: Array },
    info: { type: Object },
    isReadonly: {
      type: Boolean,
      default: function() {
        return true;
      },
    },
  },
  mounted() {
    this.setting();
  },
  data: () => ({
    headers: [],
    categories: [],
    selected: [],
    subselected: [],
    alert: false,
    rules: {
      required: value => !!value || '해당 항목을 선택해주세요.',
    },
  }),
  computed: {
    categoriesSelected() {
      if (
        !this.headers.length ||
        !this.categories.length ||
        !this.selected.length
      )
        return [];
      return this.ch.subYn !== 'Y'
        ? [this.selected]
        : [this.selected, this.subselected];
    },
  },
  methods: {
    setting: function() {
      if (this.ch) {
        this.headers = this.ch.header?.split(delimeter) ?? [];

        this.categories = [];
        this.selected = [];

        for (var i = 0; i < this.headers.length; i++) {
          if (this.headers[i]) {
            let selector = {};
            let items = [];
            selector['name'] = this.headers[i];

            for (var j = 0; j < this.ci.length; j++) {
              let row = this.ci[j].item?.split(delimeter);
              if (row[i] && items.indexOf(row[i]) < 0) {
                let type = '';

                for (var x = i - 1; x >= 0; x--) {
                  if (x !== i - 1) type += '#';
                  type += row[x];
                }

                let item = {
                  text: row[i],
                  value: row[i],
                  type: i !== 0 ? type : '',
                };
                items.push(item);
              }
            }
            selector['items'] = items;
            this.categories.push(selector);
            this.selected.push('');
            this.subselected.push('');
          }
        }
      }
      if (this.info && this.info.category) {
        this.settingData(JSON.parse(this.info.category.category), 'N');
        this.settingData(JSON.parse(this.info.category.subCategory), 'Y');
      }
    },
    settingData: function(data, subYn) {
      for (var key in data) {
        var value = data[key];
        var idx = this.headers.indexOf(key);
        if (idx > -1) {
          var item = null;
          this.categories[idx].items.forEach(function(v) {
            if (v.value === value) {
              item = v.value;
              return;
            }
          });
          if (item) {
            if (subYn == 'Y') this.subselected[idx] = item;
            else this.selected[idx] = item;
          }
        }
      }
    },
    filter(items, selectedStatus) {
      return items.filter(item =>
        !item.type
          ? true
          : item.type
              .split(delimeter)
              .reverse()
              .every((require, index) => selectedStatus[index] == require),
      );
    },
    change: function(idx, subYn) {
      for (var i = idx + 1; i < this.headers.length; i++) {
        if (subYn === 'N') {
          this.selected[i] = '';
        } else {
          this.subselected[i] = '';
        }
      }
      this.save();
    },
    valid: function() {
      return this.$refs.form.validate();
    },
    save: function() {
      let $this = this;
      let selectedItem = {};
      let subselectedItem = {};
      if (this.selected && this.selected.length > 0) {
        this.selected.forEach(function(v, i) {
          selectedItem[$this.headers[i]] = v ? v : '';
        });

        if (
          this.ch.subYn === 'Y' &&
          this.subselected &&
          this.subselected.length > 0
        ) {
          this.subselected.forEach(function(v, i) {
            subselectedItem[$this.headers[i]] = v ? v : '';
            //if (i !== 0) subselectedItem += $delimeter;
            //if (v) subselectedItem += v.value;
          });
        } else subselectedItem = selectedItem;
      }
      const p = {
        annoId: this.$route.params.annoId,
        category: JSON.stringify(selectedItem),
        subCategory: JSON.stringify(subselectedItem),
      };
      this.$emit('save', p, 'category');
    },
    savecallback: function(res) {
      if (res.status !== 200) {
        console.log('CATEGORY SAVE FAIL');
      } else snack.info(`저장 되었습니다.`);
    },
  },
};
</script>

<style>
.label-title {
  font-size: 13px;
  font-weight: bold;
  letter-spacing: -0.26px;
  color: #292929 !important;
}
</style>
